/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/utils/localstorage/getEnvironmentInLocaleStorage';

export function setEnvironmentInLocaleStorage(value: string): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value ?? ''));
}
